enum EExternalLinks {
  HJBC = 'https://hapoel.co.il/',
  HJBC_SURVEY = 'https://lp.vp4.me/tttg',
  HJBC_SHOP = 'https://www.shop.hapoel.co.il/',
  HJBC_TERMS = 'https://www.hapoel.co.il/data?id=2864',
  HJBC_WHATSAPP = 'https://api.whatsapp.com/send/?phone=26241440&text&type=phone_number&app_absent=0',
  HJBC_TICKETS = 'https://tickets.hapoel.co.il/',
  HJBC_TICKETS_TEST = 'https://hjbctest.roboticket.com/',
}

export { EExternalLinks }
